var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.832 10l7.788-7.788c.507-.506.507-1.326 0-1.832-.507-.507-1.326-.507-1.832 0L10 8.168 2.212.38C1.705-.127.887-.127.38.38c-.507.506-.507 1.326 0 1.832L8.168 10 .38 17.788c-.507.506-.507 1.325 0 1.832.253.253.584.38.916.38.332 0 .664-.127.916-.38L10 11.832l7.788 7.788c.252.253.584.38.916.38.332 0 .663-.127.916-.38.507-.507.507-1.326 0-1.832L11.832 10z",
    transform: "translate(-970.000000, -320.000000) translate(430.000000, 304.000000) translate(540.000000, 16.000000) translate(2.000000, 2.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6f72eebf.svg";
export { ForwardRef as ReactComponent };